import React from 'react';
import { Container } from './styled';
import { toJS } from 'mobx';

const Tracker = ({ detail }) => {
  const { betbleUri } = detail;

  return (
    <Container>
      <iframe
        scrolling="no"
        frameBorder="0"
        src={`https://animations.betcoapps.com/#/widget/animation?${betbleUri}&amp;lang=kor`}
      ></iframe>
    </Container>
  );
};

export default Tracker;
